var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysVision3D = function SvgSysVision3D(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M14.502.799 8.668 2.436 2.834.799.5 1.454v15.09l2.334.655 5.834-1.637 5.834 1.64 2.333-.656V1.454L14.501.799Zm-2.335 11.258-3.5-.984-3.5.984V5.941l3.5.984 3.5-.984v6.116Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.668 3.746v3.179l-5.834-1.64V17.2L.5 16.544V1.454l8.168 2.292ZM12.168 13.368l-3.5-.984v3.179l5.834 1.637V5.286l-2.334.655v7.427Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "m14.502.799 2.333.655-8.167 2.292L.5 1.454 2.834.799l5.834 1.637L14.502.799ZM8.668 11.073l3.5.984v1.31l-3.5-.983-3.5.983v-1.31l3.5-.984Z"
  })));
};
export default SvgSysVision3D;